import { gql } from "@apollo/client";

export const GET_ORDERED_PARTS = gql`
  query GetOrderedParts($query: QueryInput, $orderedPart: OrderedPartInput) {
    orderedParts(query: $query, orderedPart: $orderedPart) {
      orderedParts {
        _id
        name
        tickets {
          ticket
          ticket_id
          id
        }
        vendor_part_number
        received_date
        description
        vendor
        status
        ordered_date
        po_number
        quantity
        each_price
        shipping_price
        total_price
        payment_method
        tracking_number
        eta
        notes
        created_at
        updated_at
      }
      metaData {
        totalCount
        totalPages
      }
    }
  }
`;
